module.exports = __webpack_public_path__ + "static/media/icon-pdf.c73fae1e.svg";